<p-overlayPanel [dismissable]="false" #op>

    <div class="config-container">

        <div class="congif-panel">
            <!-- Dosya Araması -->
            <div class="config-field-g">
        
                <div class="sub-field">
                    <div>
                        <span class="icon-text">D</span>
                        <b>Dosya Araması</b>
                        <div style="color: gray">
                            Dosyalarda aramayı etkinleştirir
                        </div>
                    </div>
                    <div class="form-switch">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.patientFiles.isActive"
                            (ngModelChange)="configChanged()">
                    </div>
                </div>
        
                <div class="sub-field" [hidden]="!settings.filters.patientFiles.isActive">
                    <b>Dosya No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.patientFiles.fileNo"
                        (ngModelChange)="configChanged()">
                </div>
        
                <div class="sub-field" [hidden]="!settings.filters.patientFiles.isActive">
                    <b>Ad Soyad</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.patientFiles.name"
                        (ngModelChange)="configChanged()">
                </div>
        
                <div class="sub-field" [hidden]="!settings.filters.patientFiles.isActive">
                    <b>T.C. Kimlik No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.patientFiles.tckn"
                        (ngModelChange)="configChanged()">
                    <span style="color: gray">Tam eşleşme şartı</span>
                </div>
        
                <div class="sub-field" [hidden]="!settings.filters.patientFiles.isActive">
                    <b>Telefon Numarası</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.patientFiles.phone"
                        (ngModelChange)="configChanged()">
                    <span style="color: gray">Tam eşleşme şartı</span>
                </div>
        
            </div>
            <!--    Vaka    -->
            <div class="config-field-g">

                <div class="sub-field">
                    <div>
                        <span class="icon-text">V</span>
                        <b>Vaka Araması</b>
                        <div style="color: gray">
                            Vakalarda aramayı etkinleştirir
                        </div>
                    </div>
                    <div class="form-switch">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.case.isActive" (ngModelChange)="configChanged()">
                    </div>
                </div>

                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>Ad Soyad</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.case.name" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>Protokol No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.case.caseNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>112 Protokol No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.case.emergencyNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>Labmed Örnek Numarası</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.case.labmedNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>Sigorta Firması Provizyon No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.case.insuranceNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>Ödeme Provizyon No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.case.paymentNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>T.C. Kimlik No</b>
                    <span style="color: gray">Tam eşleşme şartı</span>
                </div>
                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>Telefon Numarası</b>
                    <span style="color: gray">Tam eşleşme şartı</span>
                </div>
            </div>

            <!--    Randevu     -->
            <div class="config-field-g">
                
                <div class="sub-field">
                    <div>
                        <span class="icon-text">R</span>
                        <b>Randevu Araması</b>
                        <div style="color: gray">
                            Randevularda aramayı etkinleştirir
                        </div>
                    </div>
                    <div class="form-switch">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.appointment.isActive" (ngModelChange)="configChanged()">
                    </div>
                </div>

                <div class="sub-field" [hidden]="!settings.filters.appointment.isActive">
                    <b>Ad Soyad</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.appointment.name" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.appointment.isActive">
                    <b>Protokol No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.appointment.caseNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.appointment.isActive">
                    <b>112 Protokol No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.appointment.emergencyNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.appointment.isActive">
                    <b>Labmed Örnek Numarası</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.appointment.labmedNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.appointment.isActive">
                    <b>Sigorta Firması Provizyon No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.appointment.insuranceNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>T.C. Kimlik No</b>
                    <span style="color: gray">Tam eşleşme şartı</span>
                </div>
                <div class="sub-field" [hidden]="!settings.filters.case.isActive">
                    <b>Telefon Numarası</b>
                    <span style="color: gray">Tam eşleşme şartı</span>
                </div>

            </div>

            <!--    Organizasyon    -->
            <div class="config-field-g">

                <div class="sub-field">
                    <div>
                        <span class="icon-text">O</span>
                        <b>Organizasyon Araması</b>
                        <div style="color: gray">
                            Organizasyonlarda aramayı etkinleştirir
                        </div>
                    </div>
                    <div class="form-switch">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.organization.isActive" (ngModelChange)="configChanged()">
                    </div>
                </div>

                <div class="sub-field" [hidden]="!settings.filters.organization.isActive">
                    <b>Organizasyon No</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.organization.orgNo" (ngModelChange)="configChanged()">
                </div>
                <div class="sub-field" [hidden]="!settings.filters.organization.isActive">
                    <b>Organizasyon Adı</b>
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.filters.organization.name" (ngModelChange)="configChanged()">
                </div>

            </div>

        </div>

        <div class="config-spliter"></div>

        <div class="congif-panel">  
            <div class="config-field">
                <div><b>Öge Arama Limiti</b>
                    <div style="color: gray">
                        Aramaya açık olan her bir ögeden en fazla kaç adet getirileceğini belirler
                    </div>
                </div>
                <input pInputText type="number" [style]="{width: '50px', 'padding-left': '3px'}" [(ngModel)]="settings.filters.limit" min="5" max="99"
                    (ngModelChange)="configChanged()" />
            </div>
            <div class="config-field">
                <div><b>Hızlı Arama Erişimi</b>
                    <div style="color: gray">
                        Aramayı hızlı etkinleştirme tuşu
                    </div>
                </div>
                <input pInputText type="text" [style]="{width: '50px', 'padding-left': '3px'}" value="F4" disabled />
            </div>
            <div class="config-field">
                <div><b>Öge Sabitleme Limiti</b>
                    <div style="color: gray">
                        Kaç adet ögenin sabitlenebileceğini belirler
                    </div>
                </div>
                <input pInputText type="number" [style]="{width: '50px', 'padding-left': '3px'}" [(ngModel)]="fixLimit" disabled />
            </div>
            <div class="config-field">
                <div><b><i class="pi pi-external-link"></i>&nbsp;Yeni Sayfada Açma</b>
                    <div style="color: gray">
                        "Sayfaya Git" aksiyonunun, yeni sayfaya yönlendirmesini sağlar
                    </div>
                </div>
                <div class="form-switch">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.openInNewPage" (ngModelChange)="configChanged()">
                </div>
            </div>
            <div class="config-field">
                <div><b><i class="pi pi-bullseye"></i>&nbsp;Otomatik Fokuslanma</b>
                    <div style="color: gray">
                        Arama modülüne erişildiğinde, arama barının otomatik olarak fokusu üzerine çekmesini sağlar
                    </div>
                </div>
                <i class="pi pi-check-circle exists-icon"></i>
            </div>
            <div class="config-field">
                <div><b><i class="pi pi-moon"></i>&nbsp;Arkaplan Karartması</b>
                    <div style="color: gray">

                    </div>
                </div>
                <div class="form-switch">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.hideBackground" (ngModelChange)="configChanged()">
                </div>
            </div>
            <div class="config-field">
                <div><b>
                        &nbsp;Favoriler Otomatik Açık Gelsin</b>
                    <div style="color: gray">

                    </div>
                </div>
                <div class="form-switch">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="settings.openFavorites" (ngModelChange)="configChanged()">
                </div>
            </div>
        </div>

    </div>


</p-overlayPanel>